import { render, staticRenderFns } from "./ShowPowerGuardQueries.vue?vue&type=template&id=088a52f0&"
import script from "./ShowPowerGuardQueries.vue?vue&type=script&lang=js&"
export * from "./ShowPowerGuardQueries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports